// src/i18n.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 导入语言文件
import en from './locales/en.js'
import ur from './locales/ur.js'

// 读取已保存的语言（默认 ur）
const savedLocale = (typeof localStorage !== 'undefined' && localStorage.getItem('locale')) || 'ur'

// 创建 VueI18n 实例
const i18n = new VueI18n({
  locale: savedLocale, // 默认语言
  fallbackLocale: 'en', // 回退语言
  messages: {
    en, // 英文语言包
    ur  // 乌尔都语语言包
  },
  silentTranslationWarn: true // 可选：禁止警告
})

// 设置页面排版方向（乌尔都语为 RTL）
if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('dir', i18n.locale === 'ur' ? 'rtl' : 'ltr')
  document.documentElement.setAttribute('lang', i18n.locale)
}

export default i18n